'use strict';
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var check_1 = require("./check");
var Arr;
(function (Arr) {
    function compact(array) {
        var length = array.length;
        var result = [];
        var index = -1;
        var resIndex = 0;
        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    }
    Arr.compact = compact;
    function difference(primaryArray, secondaryArray) {
        var set = new Set(secondaryArray);
        return primaryArray.filter(function (value) { return !set.has(value); });
    }
    Arr.difference = difference;
    function insertAt(array, index, item) {
        return __spread(array.slice(0, index), [item], array.slice(index));
    }
    Arr.insertAt = insertAt;
    function from(iterable) {
        if (!iterable) {
            return [];
        }
        if (check_1.Check.isArray(iterable)) {
            return Array.from(iterable);
        }
        if (check_1.Check.isObjectLike(iterable)) {
            if (check_1.Check.isGlobal(iterable)) {
                return [];
            }
            if (iterable instanceof Map) {
                return fromMap(iterable);
            }
            if (iterable instanceof Set) {
                return fromSet(iterable);
            }
            return Array.from(Object.values(iterable));
        }
        return [];
    }
    Arr.from = from;
    function fromMap(map) {
        return Array.from(map).map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], val = _b[1];
            return val;
        });
    }
    Arr.fromMap = fromMap;
    function fromSet(set) {
        return Array.from(set);
    }
    Arr.fromSet = fromSet;
    function map(array, iteratee) {
        var length = array === null ? 0 : array.length;
        var index = -1;
        var result = Array(length);
        while (++index < length) {
            result[index] = iteratee(array[index], index, array);
        }
        return result;
    }
    Arr.map = map;
    function pull(array, value) {
        var indexOf = array.indexOf(value);
        if (indexOf === -1) {
            return;
        }
        array.splice(indexOf, 1);
        pull(array, value);
    }
    Arr.pull = pull;
    function sortNumbers(array) {
        return array.sort(function (a, b) { return a - b; });
    }
    Arr.sortNumbers = sortNumbers;
    function sortStrings(array) {
        return array.sort(function (a, b) { return a.localeCompare(b); });
    }
    Arr.sortStrings = sortStrings;
})(Arr = exports.Arr || (exports.Arr = {}));



//////////////////
// WEBPACK FOOTER
// ./src/typescripts/shared/utils/arr.ts
// module id = 9
// module chunks = 0 1